import {
    HomeAction,
    HomeActionType,
    HomeState,
    defaultHomeState,
} from "./types";

function homeReducer(
    state: HomeState = defaultHomeState,
    action: HomeAction
): HomeState {
    switch (action.type) {
        case HomeActionType.ResetHomeCoursesState:
            state = {
                ...state,
                courses: { ...defaultHomeState.courses },
            };

            return state;

        case HomeActionType.FetchRecommendations:
            state = {
                ...state,
                recommendations: {
                    ...state.recommendations,
                    ...action.value,
                },
            };

            return state;

        case HomeActionType.FetchCourses:
            state = {
                ...state,
                courses: {
                    ...state.courses,
                    ...action.value,
                },
            };

            return state;

        default:
            return state;
    }
}

export default homeReducer;
